import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

@Injectable()
export class AccommsService {
  constructor(private http: HttpClient) { }

  getAccommodations(personId: string) {
    return this.http.get(`/api/Accommodations/getAccommodations`, {
      params: { personId: personId },
      responseType: "json"
    });
  }
  getTimingCodeAccomms(type: string) {
    return this.http.get(`/api/Accommodations/getTimingCodeAccomms`, {
      params: { type: type },
      responseType: "json"
    });
  }

  saveAccommodations(request: any): Observable<Object> {
    return this.http.post(`/api/accommodations/save`, request);
  }

  getRequestedAccommodations(requestId: string): Observable<Object[]> {
    const url = `/api/REQUESTED_ACCOMMODATIONs?filter={"where":{"REQUEST_ID":"${requestId}"}}`;
    return <Observable<Object[]>>this.http.get(url, { responseType: "json" });
  }

  getAccomsName(accomsId: string) {
    return this.http.get(`/api/Accommodations/getAccomsName`, {
      params: { type: accomsId },
      responseType: "json",
      observe: "response"
    });
  }

  getReqAccomsById(requestId: string) {
    return this.http.get(`/api/ReqAccoms/getReqAccoms`, {
      params: { type: requestId },
      responseType: "json",
      observe: "response"
    });
  }

  getAccomsCategoryName(accommCatID: string) {
    return this.http.get(`/api/AccommodationCategory/getAccomsCatName`, {
      params: { type: accommCatID },
      responseType: "json",
      observe: "response"
    });
  }

  getCompatibleAccomodations(request: any): Observable<object[]> {
    return <Observable<Object[]>>this.http.post(
      `/api/getCompatibleAccomodations`,
      request,
      {
        responseType: "json"
      }
    );
  }

  getRequests(requestId: string) {
    return this.http.get(`/api/Request/getRequestForDisplay`, {
      params: { requestId: requestId },
      responseType: "json"
    });
  }

  getInternalRequests(requestId: string) {
    return this.http.get(`/api/internalRequest/getRequestForDisplay`, {
      params: { requestId: requestId },
      responseType: "json"
    });
  }

  getRequestedStatusCode(requestStatusCodeId: string) {
    return this.http.get(`/api/RequestStatusCode/getRequestStatusCode`, {
      params: { type: requestStatusCodeId },
      responseType: "json"
    });
  }

  getRequestStatusCodeForStatus(status: string): Observable<Object[]> {
    const url = `/api/REQUEST_STATUS_CODEs/findOne?filter={"where":{"STATUS_CD":"${status}"}}`;
    return <Observable<Object[]>>this.http.get(url, { responseType: "json" });
  }
}



// WEBPACK FOOTER //
// ./client/views/services/accomms.service.ts